export default __webpack_public_path__ + "static/image-planet-fact-site-b77e62954265a53cdd648650c4ab4d7f.png";